import PlayIcon from '@mui/icons-material/PlayArrowRounded'
import styles from './TikTokPostPreview.pcss'
import { PostPreviewDefaultHeader } from './PostPreviewDefaultHeader'
import { PostPreviewVideoPlayer } from './PostPreviewVideoPlayer'
import PostPreviewText from './PostPreviewText'
import ImageCarousel from 'components/ImageCarousel'

const TRUNCATE_MAX_LINES = 2
const TRUNCATE_TEXT = 'more'
const COLLAPSE_TEXT_LABEL = 'less'

interface TikTokPostPreviewProps {
  profile?: { name: string, image: string }
  videoUrl?: string
  imageUrls?: string[]
  featuredImageUrl?: string
  videoThumbnailUrl?: string
  status?: string
  title?: string
  description?: string
}

export function TikTokPostPreview(props: TikTokPostPreviewProps) {
  const additionalImages = props.imageUrls ? props.imageUrls.filter(url => url !== props.featuredImageUrl) : []
  const carouselImages = [props.featuredImageUrl].concat(additionalImages).filter(Boolean) as string[]
  const isPhotoPost = props.imageUrls && props.imageUrls.length > 0

  return (
    <article className={`${styles.post} ${isPhotoPost ? styles['tk-photo'] : ''}`}>
      <PostPreviewDefaultHeader profile={props.profile} />
      {isPhotoPost && props.title && (
        <h3 className={styles['tk-title']}>{props.title}</h3>
      )}
      <PostPreviewText
        text={isPhotoPost ? props.description || '' : props.status || ''}
        network="tiktok"
        expandLabel={TRUNCATE_TEXT}
        collapseLabel={COLLAPSE_TEXT_LABEL}
        maxLinesDefault={TRUNCATE_MAX_LINES}
        className={styles['tk-status']}
      />
      {carouselImages.length === 0 && (
        <main className={`${styles['tk-video-box']} ${!props.videoUrl ? styles.empty : ''}`}>
          {props.videoUrl && (
            <PostPreviewVideoPlayer
              videoUrl={props.videoUrl}
              thumbnailUrl={props.videoThumbnailUrl}
              icon={<PlayIcon className={`${styles['icon-centered']} ${styles.icon}`} />}
            />
          )}
        </main>
      )}
      {carouselImages.length > 0 && (
        <div className={styles['tk-carousel']}>
          <ImageCarousel key={props.featuredImageUrl} imageUrls={carouselImages} width={400} />
        </div>
      )}
    </article>
  )
}
